import React, { useState, useEffect } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Modal,
  Box,
  CircularProgress
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import { fetchallcitylist, fetchchapterbyuser } from "src/utils/common";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { RemoveRedEye, ReplayCircleFilledOutlined } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import { getV2VDataList, getV2VRejectReason, v2vApproveReject } from "src/api/commonapi";
import Label from "src/components/Label";
import { Routes } from "../constant/api_url";
import moment from "moment";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { useLocation } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function V2VDataList() {
  const v2vApproveRejectModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  const v2vDataListModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();

  const v2vApproveRejectOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Rejected", value: 1 },
    { label: "Approved", value: 2 }
  ];
  const v2vApproveRejectfilterOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Approved", value: 2 }
  ];

  const [selectedV2VStatusData, setSelectedV2VStatusData] = useState(null);
  const [rejectReason, setRejectReason] = useState({ id: "", title: "" });
  const [v2vRejectReasonDataModal, setV2VRejectReasonDataModal] = useState(false);
  const [v2vRejectReason, setV2VRejectReason] = useState([]);
  const [v2vDataListModal, setV2VDataListModal] = useState(false);
  const [searchCall, setSearchCall] = useState(false);
  const [searchClearCall, setSearchClearCall] = useState(false);
  const [v2vDataList, setV2VDataList] = useState([]);
  const [rowdata, setRowData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  const [chaptlist, setchaplist] = useState([]);
  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : location.state?.city || 0,
    chpt_id: 0,
    m_id: 0,
    v2v_status: -1,
    v2v_req_status: -1,
    start_date: null,
    end_date: null,
    search: ""
  });
  const [v2vData, setV2VData] = useState([]);
  // const [newV2VData, setNewV2VData] = useState([]);

  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  // Open modal with v2v ID
  const openV2VApproveRejectModal = async (v2vdata) => {
    setSelectedV2VStatusData({
      ...v2vdata,
      status: v2vdata?.v2v_status // Save current status
    });

    if (v2vdata?.v2v_status == 1) {
      const matchedReason = v2vRejectReason.find(
        (r) => r.v2v_r_id === v2vdata?.v2v_reject_reason_id
      );

      if (matchedReason) {
        setRejectReason({
          id: matchedReason.v2v_r_id,
          title: matchedReason.v2v_reject_reason
        });
      } else {
        setRejectReason({ id: "", title: "" });
      }
    } else {
      setRejectReason({ id: "", title: "" });
    }

    setV2VRejectReasonDataModal(true); // Open modal
  };

  // Close modal and reset state
  const closeModal = () => {
    setV2VDataListModal(false);
  };

  const closeApproveRejectModal = () => {
    setV2VRejectReasonDataModal(false);
  };

  const handleSubmitV2VStatus = async () => {
    if (!selectedV2VStatusData?.status && selectedV2VStatusData?.status !== 0) {
      notification({ type: "error", message: "Please select a status." })();
      return;
    }

    if (selectedV2VStatusData.status === 1 && !rejectReason.id) {
      notification({ type: "error", message: "Please select a reject reason." })();
      return;
    }

    const payload = {
      v2v_by_id: selectedV2VStatusData?.v2v_by_id,
      v2v_to_id: selectedV2VStatusData?.v2v_to_id,
      v2v_id: selectedV2VStatusData?.v2v_id,
      v2v_status: selectedV2VStatusData?.status,
      v2v_approved_by: loginUser?.u_id,
      v2v_reject_reason: selectedV2VStatusData?.status == 1 ? rejectReason.id : null,
      v2v_reject_reason_title: selectedV2VStatusData?.status == 1 ? rejectReason.title : null
    };
    try {
      setIsLoading(true);

      const res = await v2vApproveReject(payload);
      setIsLoading(false);
      if (res?.status === 1) {
        let notify = notification({
          type: "success",
          message: res.message
        });
        notify();
        GetV2VData(1, searchdata);
      } else {
        let notify = notification({
          type: "error",
          message: res.message
        });
        notify();
      }
    } catch (err) {
      let notify = notification({
        type: "success",
        message: "Something went wrong!"
      });
      notify();
    }

    // Cleanup
    setV2VRejectReasonDataModal(false);
    setRejectReason({ id: "", title: "" });
    setSelectedV2VStatusData(null);
  };

  const openModalWithV2VList = (row) => {
    setV2VDataList(row?.v2v_list || []);
    setRowData(row);
    setV2VDataListModal(true);
  };

  const exportV2VDetails = [];

  v2vData.forEach((member, index) => {
    member.v2v_list.forEach((v2vItem, subIndex) => {
      exportV2VDetails.push({
        Sr: `${index + 1}.${subIndex + 1}`,
        V2V_By: member.v2v_by_mname,
        V2V_To: v2vItem.v2v_to_mname,
        Mobile: member.mobile_no,
        Email: member.m_email_id,
        Comment: v2vItem.comment,
        Image_URL: v2vItem.v2v_img ? `${Routes.API_HOSTNAME}images/v2v/${v2vItem.v2v_img}` : "",
        V2V_Date: v2vItem.v2v_date,
        V2V_Approve_Date: v2vItem.v2v_approved_date,
        Status:
          v2vItem.v2v_status == 2 ? "Approved" : v2vItem.v2v_status == 1 ? "Rejected" : "Pending",
        Reject_Reason: v2vItem.v2v_reject_reason || "",
        Rejected_Date: v2vItem.v2v_rejected_date || ""
      });
    });
  });

  const exportColumnsWithList = [
    { label: "Sr", key: "Sr" },
    { label: "V2V By Member", key: "V2V_By" },
    { label: "V2V To Member", key: "V2V_To" },
    { label: "Mobile", key: "Mobile" },
    { label: "Email", key: "Email" },
    { label: "Comment", key: "Comment" },
    { label: "Image URL", key: "Image_URL" },
    { label: "V2V Date", key: "V2V_Date" },
    { label: "V2V Approve Date", key: "V2V_Approve_Date" },
    { label: "Status", key: "Status" },
    { label: "Reject Reason", key: "Reject_Reason" },
    { label: "Reject Date", key: "Rejected_Date" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      wrap: true,
      width: "100px",
      sortable: false // Optional: disable sorting since it's just serial numbers
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row.v2v_by_mname,
      sortable: true
    },
    {
      name: "Moblie No.",
      wrap: true,
      selector: (row) => row.mobile_no,
      sortable: true
    },
    {
      name: "Email",
      wrap: true,
      selector: (row) => row.m_email_id,
      sortable: true
    },
    {
      name: "Approve Date",
      wrap: true,
      selector: (row) => {
        return row.m_verify_date !== null && row.m_verify_date !== "" ? row.m_verify_date : "-";
      },
      sortable: true
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) => {
        // const approvedCount = row.v2v_list.filter((v) => v.v2v_status === 2).length;
        // const isApproved = approvedCount >= 5;

        return (
          <Label
            variant="ghost"
            color={row?.v2v_status == 2 ? "success" : "warning"}
            style={{
              marginBottom: "10px",
              display: "flex",
              fontSize: "12px",
              fontWeight: "normal"
            }}
          >
            {row?.v2v_status == 2 ? "Approved" : "Pending"}
          </Label>
        );
      },
      width: "120px",
      sortable: false
    },
    {
      name: "Total V2V",
      width: "120px",
      selector: (row) => {
        const total = row.v2v_list.length;
        const approved = row.v2v_list.filter((v) => v.v2v_status === 2).length;
        return (
          <div>
            {approved}/{total}
          </div>
        );
      }
    },
    {
      name: "V2V List",
      width: "90px",
      cell: (row) => (
        <>
          <Tooltip title="V2V List">
            <IconButton onClick={() => openModalWithV2VList(row)}>
              <RemoveRedEye color="info" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const v2vcolumns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      wrap: true,
      width: "70px",
      sortable: false // Optional: disable sorting since it's just serial numbers
    },
    {
      name: "Image",
      wrap: true,
      width: "150px",
      cell: (row) => {
        if (row.v2v_img != null && row.v2v_img != "") {
          return (
            <a href={`${Routes.API_HOSTNAME}images/v2v/${row.v2v_img}`} target="_blank">
              <img src={`${Routes.API_HOSTNAME}images/v2v/${row.v2v_img}`} alt="img" width="100" />
            </a>
          );
        } else {
          return "No Image";
        }
      }
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row.v2v_to_mname,
      sortable: true
    },
    {
      name: "V2V Date",
      width: "110px",
      wrap: true,
      selector: (row) => row.v2v_date,
      sortable: true
    },
    {
      name: "V2V Approve Date",
      width: "110px",
      wrap: true,
      selector: (row) => row.v2v_approved_date,
      sortable: true
    },
    {
      name: "Approved/ Rejected By",
      selector: (row) => (row.approve_by_name ? row.approve_by_name : "-"),
      sortable: true,
      width: "auto",
      wrap: true
    },
    {
      name: "Status",
      wrap: true,
      width: "100px",
      selector: (row) => (
        <Label
          variant="ghost"
          color={row.v2v_status == 2 ? "success" : row.v2v_status == 1 ? "error" : "warning"}
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.v2v_status == 2 ? "Approved" : row.v2v_status == 1 ? "Rejected" : "Pending"}
        </Label>
      ),
      sortable: false
    },
    {
      name: "Approve/Reject",
      width: "120px",
      cell: (row) => (
        <>
          <Tooltip title="Approve/Reject V2V">
            <IconButton onClick={() => openV2VApproveRejectModal(row)}>
              <ReplayCircleFilledOutlined color="success" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      city_id:
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      m_id: 0,
      v2v_status: -1,
      v2v_req_status: -1,
      start_date: null,
      end_date: null,
      search: ""
    });
    GetV2VData(0, {
      city_id:
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      m_id: 0,
      v2v_status: -1,
      v2v_req_status: -1,
      start_date: null,
      end_date: null,
      search: ""
    });

    setSearchClearCall(false);
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  const getV2VRejectReasonData = async () => {
    let res = await getV2VRejectReason();
    setV2VRejectReason(res);
  };

  // const filterData = () => {
  //   let selectedCityChapter = chaptlist
  //     ?.map((chpt) => {
  //       if (searchdata?.city_id != 0) {
  //         if (chpt?.city_id == searchdata?.city_id) {
  //           return chpt.chpt_id;
  //         }
  //       } else {
  //         return chpt.chpt_id;
  //       }
  //     })
  //     .filter((f) => f != undefined);

  //   const V2VList = v2vData?.filter((v2v) => {
  //     let v2vDate = null;
  //     if (v2v.v2v_date) {
  //       // Split and parse manually: D-M-YYYY
  //       const parts = v2v.v2v_date.split("-");
  //       const day = parseInt(parts[0], 10);
  //       const month = parseInt(parts[1], 10) - 1; // Month is 0-based
  //       const year = parseInt(parts[2], 10);
  //       v2vDate = new Date(year, month, day);
  //       v2vDate.setHours(0, 0, 0, 0);
  //     }

  //     const start_date = searchdata.start_date
  //       ? new Date(searchdata.start_date.setHours(0, 0, 0, 0))
  //       : null;
  //     const end_date = searchdata.end_date ? new Date(searchdata.end_date.setHours(0, 0, 0, 0)) : null;

  //     let dateMatch = true;
  //     if (start_date && end_date && v2vDate) {
  //       dateMatch = v2vDate >= start_date && v2vDate <= end_date;
  //     }

  //     const approvedCount = v2v.v2v_list.filter((v) => v.v2v_status === 2).length;

  //     // 👇 new filter condition
  //     let statusMatch = true;
  //     if (searchdata.v2v_status === 2) {
  //       statusMatch = approvedCount >= 5;
  //     } else if (searchdata.v2v_status === 0) {
  //       statusMatch = approvedCount < 5;
  //     }

  //     const searchTerm = (searchdata?.search || "").toLowerCase();

  //     return (
  //       (v2v.chpt_id == searchdata?.chpt_id || searchdata?.chpt_id == 0) &&
  //       selectedCityChapter.length !== 0 &&
  //       selectedCityChapter.includes(v2v.chpt_id) &&
  //       statusMatch &&
  //       (searchTerm === "" ||
  //         (v2v.v2v_by_mname || "").toLowerCase().includes(searchTerm) ||
  //         (v2v.mobile_no || "").toLowerCase().includes(searchTerm) ||
  //         (v2v.m_email_id || "").toLowerCase().includes(searchTerm))

  //       // (searchdata.m_id === 0 || v2v.m_id === searchdata.m_id) &&
  //       // (searchdata.v2v_status === -1
  //       //   ? [0, 1, 2].includes(v2v.v2v_status)
  //       //   : v2v.v2v_status === searchdata.v2v_status)
  //       // &&
  //       // dateMatch
  //     );
  //   });

  //   setNewV2VData(V2VList);
  // };

  // useEffect(() => {
  //   filterData();
  // }, [searchdata, v2vData]);

  const GetV2VData = async (type = 0, data) => {
    setIsLoading(true);
    let res = await getV2VDataList({
      u_type: loginUser.u_type,
      ...data
    });
    setIsLoading(false);
    setSearchCall(false);
    if (res?.data?.length > 0) {
      setV2VData(res?.data);
      if (type === 1) {
        setV2VDataList(res?.data?.filter((item) => item?.m_id === rowdata?.m_id)[0]?.v2v_list);
      }
    } else {
      setV2VData([]);
    }
  };
  useEffect(async () => {
    GetV2VData(0, searchdata);
    getV2VRejectReasonData();
  }, []);

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.comment != null && data?.comment != "" && (
          <p>
            <b>Comment</b> : {data?.comment}
          </p>
        )}
        {data?.v2v_reject_reason != null && data?.v2v_reject_reason != "" && (
          <p>
            <b>Rejected Reason</b> : {data?.v2v_reject_reason}
          </p>
        )}
        {data?.v2v_rejected_date != null && data?.v2v_rejected_date != "" && (
          <p>
            <b>Rejected Date</b> : {data?.v2v_rejected_date}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <Page title="V2V List | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              V2V List
            </Typography>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setSearchCall(true);
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chpt_id: 0,
                        m_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchdata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setSearchCall(true);
                      setsearchdata({
                        ...searchdata,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchdata.chpt_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              {/* <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Member</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={memberdata.map((member) => {
                      if (member.m_id == searchdata.m_id) {
                        return { value: member.m_id, label: member.m_name };
                      }
                    })}
                    onChange={async (e) => {
                      setsearchdata({ ...searchdata, m_id: e.value });
                    }}
                    options={
                      memberdata &&
                      memberdata.map((option) => {
                        return { value: option.m_id, label: option.m_name };
                      })
                    }
                  />
                </Stack>
              </Grid> */}

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      v2vApproveRejectfilterOptions &&
                      v2vApproveRejectfilterOptions.map((option) => {
                        if (option.value == searchdata.v2v_status) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setSearchCall(true);
                      setsearchdata({ ...searchdata, v2v_status: e.value });
                    }}
                    options={
                      v2vApproveRejectfilterOptions &&
                      v2vApproveRejectfilterOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>
              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>V2V Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      v2vApproveRejectOptions &&
                      v2vApproveRejectOptions.map((option) => {
                        if (option.value == searchdata.v2v_req_status) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setSearchCall(true);
                      setsearchdata({ ...searchdata, v2v_req_status: e.value });
                    }}
                    options={
                      v2vApproveRejectOptions &&
                      v2vApproveRejectOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={10}>
                  <TextField
                    style={{ marginTop: "20px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Search"
                    name="name"
                    size="small"
                    autoCorrect="off"
                    value={searchdata.search}
                    onChange={(e) => {
                      setSearchCall(true);
                      setsearchdata({
                        ...searchdata,
                        search: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label>Select V2V Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata.start_date != null
                          ? moment(searchdata.start_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setSearchCall(true);
                        setsearchdata({
                          ...searchdata,
                          start_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <label>Select V2V End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata.end_date != null
                          ? moment(searchdata.end_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setSearchCall(true);
                        setsearchdata({
                          ...searchdata,
                          end_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid xs={2} item sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  <Button
                    variant="contained"
                    style={{ margin: "0 12px" }}
                    onClick={() => {
                      if (searchCall) {
                        GetV2VData(0, searchdata);
                        setSearchClearCall(true);
                      }
                    }}
                  >
                    Search
                  </Button>
                  <Button variant="outlined" onClick={() => searchClearCall && ClearSearchResult()}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px" }}>
            {v2vData && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={exportV2VDetails}
                    headers={exportColumnsWithList}
                    filename={"V2V.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={v2vData != null ? v2vData : []}
                  paginationServer={false}
                  paginationDefaultPage={currentPage}
                  paginationPerPage={rowsPerPage}
                  onChangePage={(page) => setCurrentPage(page)}
                  onChangeRowsPerPage={(newPerPage, page) => {
                    setRowsPerPage(newPerPage);
                    setCurrentPage(page);
                  }}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                  // expandableRows
                  // expandableRowsComponent={ExpandableRow}
                />
              </>
            )}
          </Card>
        </Container>

        {/* Modal for V2V Approve/Reject */}
        <Modal
          open={v2vRejectReasonDataModal}
          onClose={closeApproveRejectModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={v2vApproveRejectModalStyle}>
            <Typography variant="h6" textAlign="center" style={{ marginBottom: "20px" }}>
              Approve/Reject V2V
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 1300 })
                  }}
                  onChange={(e) => {
                    setSelectedV2VStatusData((prev) => ({
                      ...prev,
                      status: e.value
                    }));
                    if (e.value !== 1) {
                      setRejectReason({ id: "", title: "" }); // reset reject reason if not rejected
                    }
                  }}
                  value={
                    v2vApproveRejectOptions.find(
                      (option) => option.value === selectedV2VStatusData?.status
                    ) || null
                  }
                  options={v2vApproveRejectOptions
                    ?.filter((reasons) => reasons?.value != -1)
                    .map((reasons) => ({
                      label: reasons?.label,
                      value: reasons?.value
                    }))}
                />
              </Grid>
              {selectedV2VStatusData?.status === 1 && (
                <Grid item xs={12}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 1300 })
                    }}
                    onChange={(e) => {
                      setRejectReason({ id: e.value, title: e.label });
                    }}
                    value={
                      rejectReason?.id
                        ? { value: rejectReason.id, label: rejectReason.title }
                        : null
                    }
                    options={v2vRejectReason?.map((reasons) => ({
                      label: reasons?.v2v_reject_reason,
                      value: reasons?.v2v_r_id
                    }))}
                  />
                </Grid>
              )}
            </Grid>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                onClick={handleSubmitV2VStatus}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={closeApproveRejectModal}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* V2V List */}
        <Modal
          open={v2vDataListModal}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={v2vDataListModalStyle}>
            <Typography variant="h6" textAlign="center" style={{ marginBottom: "10px" }}>
              {rowdata?.v2v_by_mname} V2V List
            </Typography>
            <Card
              style={{ marginTop: "15px", maxHeight: "400px", overflow: "scroll", width: "100%" }}
            >
              <DataTable
                style={{ overflow: "hidden" }}
                filter
                pagination
                highlightOnHover
                columns={v2vcolumns}
                data={v2vDataList != null ? v2vDataList : []}
                expandableRows
                expandableRowsComponent={ExpandableRow}
                expandableRowDisabled={(row) => !row?.v2v_reject_reason}
              />
            </Card>
            <Stack direction="row" spacing={2} justifyContent="end" mt={2}>
              <Button variant="outlined" onClick={closeModal}>
                Close
              </Button>
            </Stack>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
